import * as types from "./mutation-type.js";

export default {
  setUserInfo({ commit }, userInfo) {
    commit(types.SET_USERINFO, userInfo);
  },
  isLoadingAsyn({ commit }, isLoading) {
    commit(types.SET_ISLOADING, isLoading);
  },
  tokenAsyn({ commit }, token) {
    commit(types.SET_TOKEN, token);
  },
  saveCartItemData({ commit }, cartItemData) {
    commit(types.SET_CARTITEMDATA, cartItemData);
  },
  setShowLoginModel({ commit }, isShowLoginModel) {
    commit(types.SET_SHOWLOGINMODEL, isShowLoginModel);
  },
  setAuctionRecordItem({ commit }, auctionRecordItem) {
    commit(types.SET_AUCTIONRECORDITEM, auctionRecordItem);
  }
};
